import { Alert } from "@mui/material";
import { useRouteError } from "react-router";
import { useTranslator } from "../i18n/translator";

export const ErrorPage = () => {
  const translate = useTranslator();
  const error = useRouteError();
  console.log(error);

  return <Alert severity="error">{translate("errorUnexpected")}</Alert>;
};
